interface IBudgetSummaryMobileProps {
  subtotal?: number;
  discounts?: number;
  subscriptionBalanceApplied?: number;
  totalToPay?: number;
  counterProposalValue?: number;
  counterProposalAcceptedAt?: string | null;
}

const formatCurrencyDisplay = (value: number | undefined): string => {
  if (value === undefined || value === null || value === 0) {
    return 'R$ 00,00';
  }

  const reais = Math.floor(value);
  const centavos = Math.round((value - reais) * 100);

  const formattedReais = reais.toLocaleString('pt-BR');
  const formattedCentavos = String(centavos).padStart(2, '0');

  return `R$ ${formattedReais},${formattedCentavos}`;
};

const BudgetSummaryMobile = (props: IBudgetSummaryMobileProps) => {
  return (
    <div className="text-left border border-gray-200 rounded-md p-3">
      <div className="flex flex-col gap-3">
        <div className="flex justify-between text-size-14 mb-1 text-gray-500">
          <span>Subtotal:</span>
          <span>{formatCurrencyDisplay(props.subtotal)}</span>
        </div>
        <div className="flex justify-between text-size-14 mb-1 text-green-500">
          <span>Descontos:</span>
          <span>{formatCurrencyDisplay(props.discounts)}</span>
        </div>
        {props.subscriptionBalanceApplied ? <div className="flex justify-between text-size-14 mb-1 text-green-500">
          <span>Saldo do plano utilizado:</span>
          <span>{formatCurrencyDisplay(props.subscriptionBalanceApplied)}</span>
        </div> : null}
        <div className={`flex justify-between text-size-14 font-bold mb-1 text-gray-900 ${props.counterProposalAcceptedAt ? 'line-through' : ''}`}>
          <span>Valor a ser pago:</span>
          <span>{formatCurrencyDisplay(props.totalToPay)}</span>
        </div>
        {props.counterProposalAcceptedAt && (
          <div className="flex justify-between text-size-14 font-bold mb-4 text-gray-900">
            <span>Valor a ser pago:</span>
            <span>{formatCurrencyDisplay(props.counterProposalValue)}</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default BudgetSummaryMobile;
